
import type { RouteObject } from 'react-router'
import HomePage from '../pages/home/page';
import BlogPage from '../pages/blog/page';
import BlogTrainingTipsPage from '../pages/blog/training-tips/page';
import BlogWeatherPage from '../pages/blog/weather/page';
import BlogCareerPage from '../pages/blog/career/page';
import ContactPage from '../pages/contact/page';
import GalleryPage from '../pages/gallery/page';
import TailwheelEndorsementPage from '../pages/training/tailwheel-endorsement/page';
import SportPilotPage from '../pages/training/sport-pilot/page';
import PrivatePilotPage from '../pages/training/private-pilot/page';
import NotFoundPage from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/training/tailwheel-endorsement',
    element: <TailwheelEndorsementPage />,
  },
  {
    path: '/training/sport-pilot',
    element: <SportPilotPage />,
  },
  {
    path: '/training/private-pilot',
    element: <PrivatePilotPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/training-tips',
    element: <BlogTrainingTipsPage />,
  },
  {
    path: '/blog/weather',
    element: <BlogWeatherPage />,
  },
  {
    path: '/blog/career',
    element: <BlogCareerPage />,
  },
  {
    path: '/gallery',
    element: <GalleryPage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
